import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import axios from "../../../axios";
import EmptyTable from "../../../components/EmptyTable/EmptyTable";
import * as url from "../../../utils/url";
import moment from "moment";
import { profilePicValidityCheck } from "../../../utils/constants";
import { showYou } from "../data";
import { connect } from "react-redux";
import withLoading from "../../../hoc/Loading/Loading";

function TrivvyDropoffsModal({ open, onClose, triviaId,user }) {
  const [dropOffs, setDropOffs] = useState([]);
  const [loading, setLoading] = useState(false);

  const consturctUserObjForExternalUser = (obj) => {
    if (obj.email) {
      return {
        firstName: obj.email,
        identification: "[Email]-",
      };
    } else if (obj.name) {
      const arr = obj.name.split(" ");
      return {
        identification: "[Name]-",
        firstName: arr[0],
        lastName: arr[1] || "",
      };
    } else {
      return {
        identification: "[EmployeeId]-",

        firstName: obj.employeeId,
      };
    }
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(url.getTrivvyDropoffs(triviaId))
      .then(({ data }) => {
        const mapped = data.data.map((result) => ({
          date: result.createdOn,
          user: result.userId
            ? result.userId
            : result.userData
            ? consturctUserObjForExternalUser(result.userData)
            : null,
          isAnonymous: result.isAnonymous,
        }));
        setDropOffs(mapped);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  return (
    <div>
      <Modal isOpen={open}>
        <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>View Dropoffs</ModalHeader>
        <ModalBody className="p-3">
          {loading ? (
            <h6 className="text-center my-5">Loading...</h6>
          ) : (
            <div>
              {dropOffs.length ? (
                <Table>
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    {dropOffs.map((result, idx) => {
                      return (
                        <tr>
                          <td>
                            {result.user && !result.isAnonymous ? (
                              <span className="trivia_table_text_wrapper">
                                {profilePicValidityCheck(
                                  result.user.profilePic
                                ) ? (
                                  <img
                                    src={result.user.profilePic}
                                    height="35px"
                                    width="35px"
                                    style={{ borderRadius: "50%" }}
                                  />
                                ) : (
                                  <span
                                    className="spotlightUserInitials"
                                    data-letters={getInitials(result.user)}
                                  ></span>
                                )}{" "}
                                {result.user.identification}{" "}
                                {result.user.firstName} {result.user.lastName}
                              </span>
                            ) : (
                              <span className="trivia_table_text_wrapper">
                                <span
                                  className="spotlightUserInitials"
                                  data-letters={"AU"}
                                ></span>
                                Anonymous user{" "}
                                {showYou(user.profile, result) ? "(You)" : ""}
                              </span>
                            )}
                          </td>
                          <td>{moment(result.date).format("lll")} </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              ) : (
                <div style={{
                  display:"flex",
                  justifyContent:"center",
                  alignItems:"center"
                }}>
                <EmptyTable title={"No Dropoffs found!"} />

                </div>
              )}
            </div>
          )}
        </ModalBody>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withLoading(TrivvyDropoffsModal, axios));
